export function objectToQueryString<T extends object>(obj: T) {
  if (obj === null || obj === undefined) {
    return ""
  }

  return Object.entries(obj as Record<string, unknown>)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      if (value === null || value === undefined) {
        return
      }

      if (typeof value === "object") {
        return `${encodeURIComponent(key)}=${encodeURIComponent(
          JSON.stringify(value)
        )}`
      }

      return `${encodeURIComponent(key)}=${encodeURIComponent(
        value.toString()
      )}`
    })
    .join("&")
}
